module.exports = __webpack_public_path__ + "img/Loong4.b938b811.png";